import TerminalAPI from '@/features/api/terminal/terminal'
import { getAuth, signInWithCustomToken } from '@/features/firebase/adapter/auth'
import { logger } from '@/features/firebase/logger'
import FirebaseDatabaseRefService from '@/features/firebase/services/database-ref'
import { RootState } from '@/redux/store'
import { getThunkRejectValue } from '@/redux/utils'
import { createAsyncThunk } from '@reduxjs/toolkit'
import invariant from 'tiny-invariant'

export const registerFirebase = createAsyncThunk<
    void,
    void,
    { state: Pick<RootState, 'licence' | 'auth'> }
>('registerFirebase', async (_, { getState, rejectWithValue }) => {
    const state = getState()
    const { licence } = state.licence
    const { deviceId } = state.auth

    invariant(licence && deviceId, "'licence' and 'deviceId' must be present in redux")

    let fbCustomToken: string

    try {
        fbCustomToken = await TerminalAPI.fetchFirebaseCustomToken()
    } catch (e) {
        logger.errorOnly(e)

        return rejectWithValue(getThunkRejectValue(e))
    }

    try {
        await signInWithCustomToken(getAuth(), fbCustomToken)
    } catch (e) {
        logger.errorOnly(e)

        return rejectWithValue(getThunkRejectValue(e))
    }

    FirebaseDatabaseRefService.register(licence.token, deviceId)
})
